// Axion Elite — Loading Screen
// GSAP 0→100 counter, sessionStorage-gated (first visit only).
// Loaded deferred in theme.liquid.

(function () {
  var SESSION_FLAG = '__axion_entered';

  function init() {
    var screen = document.getElementById('axion-loading-screen');
    var counter = document.getElementById('axion-counter');
    if (!screen || !counter) return;

    var alreadyEntered = sessionStorage.getItem(SESSION_FLAG);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (alreadyEntered || reduced) {
      sessionStorage.setItem(SESSION_FLAG, '1');
      screen.style.display = 'none';
      document.body.classList.add('page-ready');
      return;
    }

    // Guard: if GSAP didn't load, skip gracefully
    if (typeof gsap === 'undefined') {
      sessionStorage.setItem(SESSION_FLAG, '1');
      screen.style.display = 'none';
      document.body.classList.add('page-ready');
      return;
    }

    var state = { value: 0 };

    gsap.to(state, {
      value: 100,
      duration: 1.8,
      ease: 'power2.inOut',
      onUpdate: function () {
        counter.textContent = Math.round(state.value);
      },
      onComplete: function () {
        sessionStorage.setItem(SESSION_FLAG, '1');
        screen.classList.add('is-fading');
        setTimeout(function () {
          screen.style.display = 'none';
          document.body.classList.add('page-ready');
        }, 420);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
